import { render, staticRenderFns } from "./creditResult.vue?vue&type=template&id=4e5020c9&scoped=true"
import script from "./creditResult.vue?vue&type=script&lang=js"
export * from "./creditResult.vue?vue&type=script&lang=js"
import style0 from "./creditResult.vue?vue&type=style&index=0&id=4e5020c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5020c9",
  null
  
)

export default component.exports